import { ref } from 'vue';

const getEmployees = () => {
    const employees_error = ref(null);
    const employees = ref(null);

    const loadEmployees = async (filters = null, loadwiths = null) => {

      try {
        var params = [ ['activeonly' , 1]];

        if (filters) {
          for(const filter of filters) {
            params.push(filter);
          }
        }

        if (loadwiths) {
          for(const loadwith of loadwiths) {
            params.push(['with_' + loadwith, 1]);
          }
        }
        
        let data = await fetch("/api/employees?" + new URLSearchParams(params));

        if (!data.ok) {
          throw Error("Can't load data");
        }

        employees.value = await data.json();
      } catch (err) {
        employees_error.value = err.message;
      }
    };

    return { employees, employees_error, loadEmployees};
}

export default getEmployees;
